// Permission constants and helper utilities for MarcLife Admin

export const PERMISSION_MODULES = [
    { key: 'dashboard', label: 'Dashboard Overview', route: '/', description: 'View system analytics and summary counters', icon: 'fa fa-home' },
    { key: 'clients', label: 'Clients / Users', route: '/clients', description: 'View and manage registered clients and details', icon: 'fa fa-users' },
    { key: 'trades', label: 'Trades & P2P', route: '/trades', description: 'View orders, match statuses, and trading history', icon: 'fa fa-exchange' },
    { key: 'rank', label: 'Rank & Achievers', route: '/rank', description: 'View rank tiers, salaries, and achievers history', icon: 'fa fa-trophy' },
    { key: 'rewards', label: 'Rewards & Offers', route: '/rewards', description: 'Create and manage promotional targets, tours, and reward campaigns', icon: 'fa fa-gift' },
    { key: 'matching', label: 'Matching Bonus', route: '/matching-bonus', description: 'View binary matching bonuses and trigger distribution', icon: 'fa fa-cubes' },
    { key: 'withdrawals', label: 'Withdrawal History', route: '/client-withdraw', description: 'View client withdrawals, approve/reject requests', icon: 'fa fa-money' },
    { key: 'master_wallet', label: 'Master Wallet', route: '/master-wallet', description: 'Monitor liquidity, reserves, and master wallets', icon: 'fa fa-wallet' },
    { key: 'treasury', label: 'Blockchain Treasury', route: '/treasury', description: 'MultiSig Treasury smart contract on BSC (Read/Write)', icon: 'fa fa-university' },
    { key: 'support', label: 'Support & Tickets', route: '/support', description: 'Manage client tickets, inquiries, and issue replies', icon: 'fa fa-comments' },
    { key: 'subadmins', label: 'Sub-Admin Management', route: '/admin', description: 'Create and assign module permissions to sub-admins', icon: 'fa fa-user-shield' },
    { key: 'notifications', label: 'Notifications', route: '/notification', description: 'Send and broadcast announcements to users', icon: 'fa fa-bell' },
    { key: 'settings', label: 'Platform Settings', route: '/setting', description: 'Configure platform parameters, contracts, and fees', icon: 'fa fa-cog' },
];

// Read current logged-in admin object from sessionStorage
export const getLoggedAdmin = () => {
    try {
        const raw = sessionStorage.getItem('adminUser');
        if (raw) return JSON.parse(raw);
    } catch (e) {
        console.error('Error parsing adminUser from sessionStorage:', e);
    }
    return null;
};

// Check if current user is Master Admin
export const isMasterAdmin = (adminObj) => {
    const admin = adminObj || getLoggedAdmin();
    if (!admin) return false;
    const role = (admin.user_role || '').toLowerCase().trim();
    return role === 'master admin' || role.includes('master');
};

// Get permission for a specific module: returns 'none', 'viewer', or 'editor'
export const getModulePermission = (moduleKey, adminObj) => {
    const admin = adminObj || getLoggedAdmin();
    if (!admin) return 'none';

    // Master Admin has full Editor access to every module
    if (isMasterAdmin(admin)) {
        return 'editor';
    }

    // Sub-Admin permissions mapping
    let perms = admin.permissions;
    if (typeof perms === 'string') {
        try {
            perms = JSON.parse(perms);
        } catch (e) {
            perms = {};
        }
    }

    if (!perms || typeof perms !== 'object') {
        return 'none';
    }

    const val = (perms[moduleKey] || 'none').toLowerCase().trim();
    if (val === 'editor' || val === 'edit') return 'editor';
    if (val === 'viewer' || val === 'view') return 'viewer';
    return 'none';
};

// Can user view the module? (returns true for viewer or editor)
export const hasModuleAccess = (moduleKey, adminObj) => {
    const perm = getModulePermission(moduleKey, adminObj);
    return perm === 'viewer' || perm === 'editor';
};

// Can user edit / perform actions in the module? (returns true only for editor)
export const canModuleEdit = (moduleKey, adminObj) => {
    const perm = getModulePermission(moduleKey, adminObj);
    return perm === 'editor';
};
